// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/farm.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Farm } from "../farm/farm";
import { Id, Point } from "../geo/geo";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.portal.farm";

export interface CreateFarmRequest {
  farm: Farm | undefined;
}

export interface UpdateFarmRequest {
  /**
   * Patch updates to the farm. Descendant `VersionInfo`s must retain the
   * `ordinal` of the last copy that this client received from the server, for
   * merging purposes. To delete an entity, flip `deleted` from `false` to
   * `true`. To update an entity, set `changed` to `true` and edit the fields
   * on the entity.
   */
  farm: Farm | undefined;
}

export interface ListFarmsRequest {
  /**
   * Cursor from `ListFarmsResponse.next_page_token` on a previous response.
   * If blank, starts from the beginning.
   */
  pageToken: string;
}

export interface ListFarmsResponse {
  farms: Farm[];
  /**
   * Cursor for `ListFarmsRequest.page_token`. If blank, there are no further
   * pages.
   */
  nextPageToken: string;
}

export interface GetFarmRequest {
  /** ID of the farm to get. */
  id:
    | Id
    | undefined;
  /** If specified, this is a conditional request; see `FarmsService.GetFarm`. */
  ifModifiedSince: string | undefined;
}

export interface GetContainingFarmRequest {
  /** Point that will be resolved to the containing farm. */
  point: Point | undefined;
}

export interface GetFarmResponse {
  farm: Farm | undefined;
}

function createBaseCreateFarmRequest(): CreateFarmRequest {
  return { farm: undefined };
}

export const CreateFarmRequest: MessageFns<CreateFarmRequest> = {
  encode(message: CreateFarmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.farm !== undefined) {
      Farm.encode(message.farm, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFarmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFarmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.farm = Farm.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFarmRequest {
    return { farm: isSet(object.farm) ? Farm.fromJSON(object.farm) : undefined };
  },

  toJSON(message: CreateFarmRequest): unknown {
    const obj: any = {};
    if (message.farm !== undefined) {
      obj.farm = Farm.toJSON(message.farm);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFarmRequest>, I>>(base?: I): CreateFarmRequest {
    return CreateFarmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFarmRequest>, I>>(object: I): CreateFarmRequest {
    const message = createBaseCreateFarmRequest();
    message.farm = (object.farm !== undefined && object.farm !== null) ? Farm.fromPartial(object.farm) : undefined;
    return message;
  },
};

function createBaseUpdateFarmRequest(): UpdateFarmRequest {
  return { farm: undefined };
}

export const UpdateFarmRequest: MessageFns<UpdateFarmRequest> = {
  encode(message: UpdateFarmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.farm !== undefined) {
      Farm.encode(message.farm, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFarmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFarmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.farm = Farm.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFarmRequest {
    return { farm: isSet(object.farm) ? Farm.fromJSON(object.farm) : undefined };
  },

  toJSON(message: UpdateFarmRequest): unknown {
    const obj: any = {};
    if (message.farm !== undefined) {
      obj.farm = Farm.toJSON(message.farm);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFarmRequest>, I>>(base?: I): UpdateFarmRequest {
    return UpdateFarmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFarmRequest>, I>>(object: I): UpdateFarmRequest {
    const message = createBaseUpdateFarmRequest();
    message.farm = (object.farm !== undefined && object.farm !== null) ? Farm.fromPartial(object.farm) : undefined;
    return message;
  },
};

function createBaseListFarmsRequest(): ListFarmsRequest {
  return { pageToken: "" };
}

export const ListFarmsRequest: MessageFns<ListFarmsRequest> = {
  encode(message: ListFarmsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListFarmsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListFarmsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListFarmsRequest {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
    };
  },

  toJSON(message: ListFarmsRequest): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFarmsRequest>, I>>(base?: I): ListFarmsRequest {
    return ListFarmsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListFarmsRequest>, I>>(object: I): ListFarmsRequest {
    const message = createBaseListFarmsRequest();
    message.pageToken = object.pageToken ?? "";
    return message;
  },
};

function createBaseListFarmsResponse(): ListFarmsResponse {
  return { farms: [], nextPageToken: "" };
}

export const ListFarmsResponse: MessageFns<ListFarmsResponse> = {
  encode(message: ListFarmsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.farms) {
      Farm.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== "") {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListFarmsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListFarmsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.farms.push(Farm.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListFarmsResponse {
    return {
      farms: globalThis.Array.isArray(object?.farms) ? object.farms.map((e: any) => Farm.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
    };
  },

  toJSON(message: ListFarmsResponse): unknown {
    const obj: any = {};
    if (message.farms?.length) {
      obj.farms = message.farms.map((e) => Farm.toJSON(e));
    }
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFarmsResponse>, I>>(base?: I): ListFarmsResponse {
    return ListFarmsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListFarmsResponse>, I>>(object: I): ListFarmsResponse {
    const message = createBaseListFarmsResponse();
    message.farms = object.farms?.map((e) => Farm.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? "";
    return message;
  },
};

function createBaseGetFarmRequest(): GetFarmRequest {
  return { id: undefined, ifModifiedSince: undefined };
}

export const GetFarmRequest: MessageFns<GetFarmRequest> = {
  encode(message: GetFarmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      Id.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.ifModifiedSince !== undefined) {
      Timestamp.encode(toTimestamp(message.ifModifiedSince), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFarmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFarmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = Id.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ifModifiedSince = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFarmRequest {
    return {
      id: isSet(object.id) ? Id.fromJSON(object.id) : undefined,
      ifModifiedSince: isSet(object.ifModifiedSince)
        ? globalThis.String(object.ifModifiedSince)
        : isSet(object.if_modified_since)
        ? globalThis.String(object.if_modified_since)
        : undefined,
    };
  },

  toJSON(message: GetFarmRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = Id.toJSON(message.id);
    }
    if (message.ifModifiedSince !== undefined) {
      obj.ifModifiedSince = message.ifModifiedSince;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFarmRequest>, I>>(base?: I): GetFarmRequest {
    return GetFarmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFarmRequest>, I>>(object: I): GetFarmRequest {
    const message = createBaseGetFarmRequest();
    message.id = (object.id !== undefined && object.id !== null) ? Id.fromPartial(object.id) : undefined;
    message.ifModifiedSince = object.ifModifiedSince ?? undefined;
    return message;
  },
};

function createBaseGetContainingFarmRequest(): GetContainingFarmRequest {
  return { point: undefined };
}

export const GetContainingFarmRequest: MessageFns<GetContainingFarmRequest> = {
  encode(message: GetContainingFarmRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.point !== undefined) {
      Point.encode(message.point, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetContainingFarmRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetContainingFarmRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.point = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetContainingFarmRequest {
    return { point: isSet(object.point) ? Point.fromJSON(object.point) : undefined };
  },

  toJSON(message: GetContainingFarmRequest): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = Point.toJSON(message.point);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetContainingFarmRequest>, I>>(base?: I): GetContainingFarmRequest {
    return GetContainingFarmRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetContainingFarmRequest>, I>>(object: I): GetContainingFarmRequest {
    const message = createBaseGetContainingFarmRequest();
    message.point = (object.point !== undefined && object.point !== null) ? Point.fromPartial(object.point) : undefined;
    return message;
  },
};

function createBaseGetFarmResponse(): GetFarmResponse {
  return { farm: undefined };
}

export const GetFarmResponse: MessageFns<GetFarmResponse> = {
  encode(message: GetFarmResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.farm !== undefined) {
      Farm.encode(message.farm, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFarmResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFarmResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.farm = Farm.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFarmResponse {
    return { farm: isSet(object.farm) ? Farm.fromJSON(object.farm) : undefined };
  },

  toJSON(message: GetFarmResponse): unknown {
    const obj: any = {};
    if (message.farm !== undefined) {
      obj.farm = Farm.toJSON(message.farm);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFarmResponse>, I>>(base?: I): GetFarmResponse {
    return GetFarmResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFarmResponse>, I>>(object: I): GetFarmResponse {
    const message = createBaseGetFarmResponse();
    message.farm = (object.farm !== undefined && object.farm !== null) ? Farm.fromPartial(object.farm) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
